module.exports = __webpack_public_path__ + "img/video_call.f76d91a8.png";